var map = {
	"./pratica-1-es.json": "01cc",
	"./pratica-1.json": "f68d",
	"./pratica-13.json": "82dd",
	"./pratica-2.json": "dd58",
	"./pratica-3.json": "8fb3",
	"./pratica-4.json": "707c",
	"./pratica-6A.json": "4233",
	"./pratica-6B-es.json": "bd9b",
	"./pratica-6B.json": "76a8",
	"./pratica-6C.json": "07fb",
	"./pratica-7.json": "722f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e76c";